export default "__VITE_ASSET__7eb4a442__"